import styled from 'styled-components';
import { Flex } from 'onefaceui-react-components';

export const FormContainer = styled.div`
  padding: 12px 16px;

  fieldset {
    width: 100%;
  }
  input {
    width: 100%;
    height: 30px !important;
  }

  .generic-modal__modal-body-container {
    padding: 0;
  }

  label {
    margin-bottom: 5px;
  }

  .oneface-select div:nth-child(4) {
    position: relative !important;
    left: 0;
    top: 0;
  }
`;

export const ModalFooter = styled(Flex)`
  padding: 14px 20px;
  box-shadow: 0px 0px 6px #00000029;
  border-radius: 0px 0px 4px 4px;
  background-color: #fff;
`;
